

import React from 'react';
import createSagaMiddleware from 'redux-saga';
import { render } from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import createLogger from 'redux-logger';
import reducer from '../src/reducer';
import App from '../src/App';
import rootSaga from './sagas';
import { buildtype } from './config';


const sagaMiddleware = createSagaMiddleware();
let store2;
if (buildtype === "prod") {
  store2 = compose(applyMiddleware(sagaMiddleware));
} else {
  store2 = compose(applyMiddleware(sagaMiddleware, createLogger));
}

const store = createStore(reducer, store2);
sagaMiddleware.run(rootSaga);


render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
